module.exports = __webpack_public_path__ + "static/img/def.defb8d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat_files/def.png
// module id = Zrk4
// module chunks = 4